import { gql } from 'graphql-tag';

export const CreateCompanyDocument = gql`
  mutation CreateCompany($data: CompanyCreateInput!) {
    company: createCompany(data: $data) {
      id
      name
    }
  }
`;

export const UpdateCompanyDocument = gql`
  mutation UpdateCompany($data: CompanyUpdateInput!, $where: CompanyWhereUniqueInput!) {
    company: updateCompany(data: $data, where: $where) {
      id
      name
    }
  }
`;

export const GetCompanyDocument = gql`
  query GetCompany($id: ID) {
    company: Company(id: $id) {
      id
      name
      code
      supportEmail
      active
      extended
      visibleVMCategories
      defaultOrderStatus
      membershipPointsPercentage
      serviceFee
      languages
      defaultLanguage
      currencies
      defaultCurrency
      loginMethods

      hasCashback
      hasMembershipCards
      hasAppOrders
      hasPoints
      hasPOS
      hasKDS
      hasCDS
      hasTables
      hasExpress
      hasInventory
      timezone
      manualEndOfDay
      referralsEnabled

      defaultCountryCode

      referralShareMessage {
        id
        en
        se
        es
      }

      referralTitle {
        id
        en
        se
        es
      }

      referralBody {
        id
        en
        se
        es
      }

      referralOffer {
        id
        name
      }
      referrerOffer {
        id
        name
      }
    }
  }
`;

export const GetCompanyOffersDocument = gql`
  query GetCompanyOffers($companyId: ID!) {
    company: Company(id: $companyId) {
      id
      name
      offers(context: [POS, APP]) {
        id
        nameLang {
          id
          en
          se
          es
        }
      }
    }
  }
`;

export const GetCompanyLicensesDocument = gql`
  query GetCompanyLicenses($companyId: ID!) {
    company: Company(id: $companyId) {
      id
      licenses {
        id
        plan
        status
        createdAt
        expiresAt
      }
    }
  }
`;

export const CreateCompanyLicenseDocument = gql`
  mutation CreateCompanyLicense(
    $companyId: String!
    $plan: PRODUCT_TYPE!
    $provider: LICENSE_PROVIDER!
    $accountId: String
  ) {
    manageLicense(
      create: { companyId: $companyId, plan: $plan, provider: $provider, accountId: $accountId }
    ) {
      success
      message
      error
    }
  }
`;

export const CancelCompanyLicenseDocument = gql`
  mutation CancelCompanyLicense($LicenseId: String!) {
    manageLicense(cancel: { licenseId: $LicenseId }) {
      success
      message
      error
    }
  }
`;
